module.exports = __webpack_public_path__ + "static/img/4.9d07576.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news19/4.png
// module id = Gej+
// module chunks = 1